import type { FlagConfiguration } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import messages from './messages.tsx';

// This is a substring of the error message returned from the BE when the user is unable to edit a field on an issue,
// either because they do not have permissions to do so or the field isn't supported by the issue type
export const KNOWN_ERROR_MESSAGE = 'It is not on the appropriate screen, or unknown.';

// This is the error message returned from the BE when the user tries to create a category
// with the same name as an already existing category
export const CATEGORY_NAME_ALREADY_EXISTS_ERROR_MESSAGE = 'Category with the same name exists';

export const CATEGORY_NAME_ALREADY_EXISTS_ERROR_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.categoryNameAlreadyExists,
	messageType: 'transactional',
};
